import dayjs from "dayjs";

export const DEFAULT_REPORT_TABLE_FILTERS: ReportTableFilters = {
	regionId: undefined,

	areaId: undefined,

	storeId: undefined,

	userId: undefined,

	showCompliantReport: undefined,

	showObservationsPassedThresholdReport: undefined,

	month: undefined,

	year: dayjs().year(),

	showGradingReport: undefined,

	calendarMonth: undefined,
	
	areaDisabled: false,

	regionDisabled: false,

	storeDisabled: false
};
